import { type KnackField } from '@/types/schema/KnackField';

export function isValidDisplayField(KnackField: KnackField): boolean {
  const invalidDisplayFieldTypes = ['signature', 'file', 'image', 'rating'];
  return !invalidDisplayFieldTypes.includes(KnackField.type);
}
